module.exports = __webpack_public_path__ + "img/logo.35a13d1b.jpg";